module.exports = "<div :class=wrapperClasses> <div v-for=\"cl in colors\" :class=\"['spinner-layer', colors.length === 1 ? 'spinner-' + cl + '-only' : 'spinner-' + cl]\"> <div class=\"circle-clipper left\"> <div class=circle></div> </div> <div class=gap-patch> <div class=circle></div> </div> <div class=\"circle-clipper right\"> <div class=circle></div> </div> </div> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ../~/vue-html-loader!../~/vue-loader/lib/selector.js?type=template&index=0!../~/material-ui-vue/components/progresses/circle-progress.vue
 ** module id = 366
 ** module chunks = 0
 **/